
import HttpClient from '../HttpService';

// Gerar o PDF passa por Puppeteer, merge dos anexos e upload no S3, então precisa de
// uma folga maior que o resto da API — mas nunca "para sempre": sem teto, uma request
// que o backend deixasse pendurada travava a tela de vez.
const AVALIATION_REPORT_TIMEOUT_MS = 120000;

function avaliationReport({ record_id, image, file_ids = [] }, signal) {
    return HttpClient.post(
        `/reports/avaliation`,
        { record_id, image, file_ids },
        { timeout: AVALIATION_REPORT_TIMEOUT_MS, signal }
    );
}

function downloadReportUrl(key) {
    const base = process.env.VUE_APP_ROOT_API || '';
    const params = new URLSearchParams({ key });
    return `${base}/reports/download?${params.toString()}`;
}

export default {
    avaliationReport,
    downloadReportUrl
}
